import Promise from 'promise-polyfill'

const Worklist = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {}
  },
  actions: {
    getActiveWorklistById: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.approval.getActiveWorklistByIdUsingGET({id: payload.id})
          .then(res => resolve({body: res.body, obj: res.obj}))
          .catch(err => reject(err))
      })
    },
    getApprovalByToUser: (context, payload) => {
      const vue = payload.vueinstance

      return new Promise((resolve, reject) => {
        vue.$backend.approval.getApprovalByToUserUsingGET({empid: payload.empid})
          .then(res => resolve(res.body))
          .catch(err => reject(err))
      })
    },
    worklistCount: (context, payload) => {
      return new Promise((resolve, reject) => {
        context.dispatch('getApprovalByToUser', payload)
          .then(res => resolve(res.length)).catch(err => reject(err))
      })
    },
    emailWorklistById: (context, payload) => {
      const vue = payload.vueinstance

      return new Promise((resolve, reject) => {
        vue.$backend.approval.emailWorklistByIdUsingPUT({id: payload.id, obj: payload.obj})
          .then(res => resolve(res.body))
          .catch(err => reject(err))
      })
    },
    reset: (context, payload) => {
      context.commit('reset', payload)
    }
  }
}

export default Worklist



// WEBPACK FOOTER //
// ./src/store/worklist/index.js